import { translate } from '@/utilities';
import capitalizeFirstLetter from '@/utilities/capitalizeFirstLetter';
import constants from '@/utilities/constants';

const getIntervalText = (due, now) => {
  if (due === now) return translate('today');
  return due > now ? translate('tomorrow') : translate('yesterday');
};

// Add char ~ to the start of the string if unit is year or month and capitalize the first letter
const generateReadableLabel = (string, unit) =>
  `${unit === 'year' || unit === 'month' ? '~' : ''} ${capitalizeFirstLetter(string)}`;

/**
 * Human readable elapsed or remaining time (example: 3 minutes ago)
 * @param  {Date|Number|String} date
 * A Date object, timestamp or string parsable with Date.parse()
 * @param  {Date|Number|String} [nowDate]
 * A Date object, timestamp or string parsable with Date.parse()
 * @param  {Intl.RelativeTimeFormat} [trf] A Intl formater.
 * Undefined parameter can be replaced with language string from state.
 * @return {string} Human readable elapsed or remaining time
 */
const getHumanReadableDate = (
  date,
  nowDate = Date.now(),
  rft = new Intl.RelativeTimeFormat(undefined, { numeric: 'auto' })
) => {
  const { DAY, MONTH, YEAR } = constants;
  const dueDate = typeof date === 'object' ? date : new Date(date);
  const now = typeof nowDate === 'object' ? nowDate : new Date(nowDate);
  const diff = now.getTime() - dueDate.getTime();
  const diffAbs = Math.abs(diff);
  const nowGetDate = now.getDate();
  const dueDateGetDate = dueDate.getDate();
  const intervalText = getIntervalText(dueDateGetDate, nowGetDate);
  const intervals = [
    { ge: YEAR, divisor: YEAR, unit: 'year' },
    { ge: MONTH, divisor: MONTH, unit: 'month' },
    { ge: DAY, divisor: DAY, unit: 'day' },
    { ge: 0, divisor: 1, text: intervalText },
  ];
  for (let i = 0; i < intervals.length; i += 1) {
    const interval = intervals[i];
    if (diffAbs >= interval.ge) {
      const x = Math.round(Math.abs(diff) / interval.divisor);
      const isFuture = diff < 0;
      const formatX = isFuture ? x : -x;
      return interval.unit
        ? generateReadableLabel(rft.format(formatX, interval.unit), interval.unit)
        : generateReadableLabel(interval.text);
    }
  }
  return '';
};

export { getHumanReadableDate, getIntervalText, generateReadableLabel };
